import React, { memo, useContext, useEffect, useMemo, useRef, useState } from "react";
import "react-spring-bottom-sheet/dist/style.css";
import "reactjs-popup/dist/index.css";
import ImagemModal from "../../assets/images/imagem_empresa_modal.jpg";
import WaybeImagemGrande from "../../assets/images/waybe_logo.png";
import { ReactComponent as IconeExpandir } from "../../assets/icons/expand_more.svg";
import { ReactComponent as IconeLoja } from "../../assets/icons/storefront.svg";
import { ReactComponent as IconeMenuMobile } from "../../assets/icons/more_vert.svg";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import * as S from "./styles";
import ComponentePaginado from "../ComponentePaginado";
import Configuracoes from "../BotaoConfiguracao";
import ExpandableSearch from "./components/ExpandableSearch";
import Notificacoes from "../BotaoNotificacoes";
import Perfil from "../BotaoPerfil";
import SelecionarEmpresaPopup from "../ModalSelecionarEmpresasPopup";
import TabelaOrdenada from "../TabelaOrdenada";
import removerCaracteresEspeciais from "../../utils/removerCaracteresEspeciais";
import tornarSlider from "../../utils/tornarSlider";
import useTamanhoTela from "../../utils/useTamanhoTela";
import { BotaoEngrenagem } from "../BotaoEngrenagem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconeBotao } from "../../pages/selecaoEmpresas/styles";
import { MagnifyingGlass, X } from "phosphor-react";
import { TemaCustomizadoContext } from "../../contexts/theme";
import { useApi } from "../../contexts/api";
import { useAuth } from "../../contexts/auth";
import { useLoader } from "../../contexts/loader";
import { useMenu } from "../../contexts/menu";
import { useNavigate, useLocation } from "react-router-dom";
import { usePermissoesLocalStorage } from "../../utils/usePermissoesLocalStorage";
import { obterStorage } from "../../utils/secureStorage";
import { useAssistenteIA } from "../../contexts/assistenteIA";
import BotaoAssistente from "./components/BotaoAssistente";

export const menusLiberados = [];

const LinhaMenus = memo(
  ({ menusLiberados, menuFixo, rotaCardapio, MenuItemNovo }) => {
    const refMenuScroll = useRef();
    useEffect(() => {
      tornarSlider(refMenuScroll.current);
    }, []);

    return (
      <S.LinhaMenusContainer ref={refMenuScroll} menuFixo={menuFixo} rotaCardapio={rotaCardapio}>
        {menusLiberados.map((menu, index) => (
          <MenuItemNovo
            menu={menu}
            titulo={menu.nome}
            key={menu.nome + index}
          />
        ))}
      </S.LinhaMenusContainer>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.menusLiberados === nextProps.menusLiberados &&
      prevProps.menuFixo === nextProps.menuFixo &&
      prevProps.rotaCardapio === nextProps.rotaCardapio
    );
  },
);

const Header = ({ paginaCashback, edicao = false, nomeCashback = "" }) => {
  const { verificarPermissao } = usePermissoesLocalStorage();
  const { getTemaDarkAtivo } = useContext(TemaCustomizadoContext);
  const theme = useTheme();

  const { get } = useApi();
  const { atualizarMenu, abrirCarregamento, fecharCarregamento } = useLoader();
  const { largura } = useTamanhoTela();
  const { trocarEmpresa, contratoWaychefAtivo } = useAuth();
  const [menuFixo, setMenuFixo] = useState(false);
  const [mostrarModalSelecionarEmpresaPopup, setMostrarModalSelecionarEmpresaPopup] =
    useState(false);
  const [listaMenuAtual, setListaMenuAtual] = useState();

  const LARGURA_QUEBRA = 864;
  const versaoDesktopAtiva = largura > LARGURA_QUEBRA;
  const { iaDisponivel } = useAssistenteIA();
  const [abrir, setAbrir] = useState(false);

  const {
    listaMenu,
    atualizarHeaderFixo,
    buscarDadosEmpresaStorage,
    dadosEmpresa,
    buscarDashboards,
    listaDashboards,
  } = useMenu();

  const navigate = useNavigate();

  const criarDashboardNovo = () => ({
    nome: "Novo",
    onClick: () => navigate("/dashboard/novo"),
  });

  const listarDashboardsComBotaoNovo = () => {
    const dashboards = Array.isArray(listaDashboards) ? listaDashboards : [];
    const possuiBotaoNovo = dashboards.some((item) => item?.nome === "Novo");

    return possuiBotaoNovo ? dashboards : [...dashboards, criarDashboardNovo()];
  };

  const location = useLocation();

  function fecharModal() {
    setAbrir(false);
  }

  const funcoesBotaoNavegacao = {
    function: (filho) => {
      filho();
    },
    string: (filho) => {},
  };

  const useScrollDirection = () => {
    const THRESHOLD = 0;
    const [scrollDirection, setScrollDirection] = React.useState("up");

    const blocking = React.useRef(false);
    const prevScrollY = React.useRef(0);

    React.useEffect(() => {
      prevScrollY.current = window.pageYOffset;

      const updateScrollDirection = () => {
        const scrollY = window.pageYOffset;

        if (Math.abs(scrollY - prevScrollY.current) >= THRESHOLD) {
          const newScrollDirection = scrollY > prevScrollY.current ? "down" : "up";

          setScrollDirection(newScrollDirection);

          prevScrollY.current = scrollY > 0 ? scrollY : 0;
        }

        blocking.current = false;
      };

      const onScroll = () => {
        if (!blocking.current) {
          blocking.current = true;
          window.requestAnimationFrame(updateScrollDirection);
        }
      };

      window.addEventListener("scroll", onScroll);

      return () => window.removeEventListener("scroll", onScroll);
    }, [scrollDirection]);

    return scrollDirection;
  };

  const dadosTabela = () => {
    return {
      paginas: 20,
      pagina: 1,
      colunas: [
        { expandivel: false, valor: " " },
        { expandivel: false, valor: "" },
        { expandivel: false, valor: "Nome Fantasia" },
        { expandivel: false, valor: "Tipo" },
        { expandivel: false, valor: "Grupo" },
        { expandivel: false, valor: "Integrador" },
        { expandivel: false, valor: "Insc.Federal" },
        { expandivel: false, valor: "Cidade" },
        { expandivel: false, valor: "UF" },
        { expandivel: false, valor: "Plano" },
        { expandivel: false, valor: "Assinatura" },
        { expandivel: false, valor: "Data Cadastro" },
        { valor: "  " },
      ],
      dados: [
        {
          " ": <S.TextoVisualizar>Visualizar</S.TextoVisualizar>,
          "": <S.ImgEmpresaModal src={ImagemModal} />,
          "Nome Fantasia": "Waychef",
          Descrição: "Desconto 10%",
          Tipo: "Franqueado",
          Grupo: "Matriz",
          Integrador: "PRODATI",
          "Insc.Federal": "410.095.320-81",
          Cidade: "São Paulo",
          UF: "SP",
          Plano: "Bronze",
          Assinatura: "Mensal",
          "Data Cadastro": "07/11/2022",
        },
        {
          " ": <S.TextoVisualizar>Visualizar</S.TextoVisualizar>,
          "": <S.ImgEmpresaModal src={ImagemModal} />,
          "Nome Fantasia": "Waychef",
          Descrição: "Desconto 10%",
          Tipo: "Franqueado",
          Grupo: "Matriz",
          Integrador: "PRODATI",
          "Insc.Federal": "410.095.320-81",
          Cidade: "São Paulo",
          UF: "SP",
          Plano: "Bronze",
          Assinatura: "Mensal",
          "Data Cadastro": "07/11/2022",
        },
        {
          " ": <S.TextoVisualizar>Visualizar</S.TextoVisualizar>,
          "": <S.ImgEmpresaModal src={ImagemModal} />,
          "Nome Fantasia": "Waychef",
          Descrição: "Desconto 10%",
          Tipo: "Franqueado",
          Grupo: "Matriz",
          Integrador: "PRODATI",
          "Insc.Federal": "410.095.320-81",
          Cidade: "São Paulo",
          UF: "SP",
          Plano: "Bronze",
          Assinatura: "Mensal",
          "Data Cadastro": "07/11/2022",
        },
        {
          " ": <S.TextoVisualizar>Visualizar</S.TextoVisualizar>,
          "": <S.ImgEmpresaModal src={ImagemModal} />,
          "Nome Fantasia": "Waychef",
          Descrição: "Desconto 10%",
          Tipo: "Franqueado",
          Grupo: "Matriz",
          Integrador: "PRODATI",
          "Insc.Federal": "410.095.320-81",
          Cidade: "São Paulo",
          UF: "SP",
          Plano: "Bronze",
          Assinatura: "Mensal",
          "Data Cadastro": "07/11/2022",
        },
        {
          " ": <S.TextoVisualizar>Visualizar</S.TextoVisualizar>,
          "": <S.ImgEmpresaModal src={ImagemModal} />,
          "Nome Fantasia": "Waychef",
          Descrição: " PRODATIDesconto 10%",
          Tipo: "Franqueado",
          Grupo: "Matriz",
          Integrador: "PRODATI",
          "Insc.Federal": "410.095.320-81",
          Cidade: "São Paulo",
          UF: "SP",
          Plano: "Bronze",
          Assinatura: "Mensal",
          "Data Cadastro": "07/11/2022",
        },
      ],
    };
  };

  const handleScroll = () => {
    const position = window.pageYOffset;

    if (position > 130) {
      setMenuFixo(true);
    } else {
      setMenuFixo(false);
    }

    if (position > 160) {
      atualizarHeaderFixo(true);
    } else {
      atualizarHeaderFixo(false);
    }
  };

  const identificarRotaSelecionada = (rotaAtual) => {
    try {
      if (location.pathname == "/" && rotaAtual == "dashboard") {
        return true;
      }

      if (rotaAtual === "produtos") return false;

      const rota = location.pathname.split("/");

      if (rota[1] == rotaAtual) {
        return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    buscarDadosEmpresaStorage();

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (listaDashboards != undefined) {
      try {
        if (!listaMenuAtual?.menus) {
          return;
        }

        const menus = {
          ...listaMenuAtual,
          menus: [...listaMenuAtual.menus],
        };

        const sessao = obterStorage("sessao");
        const indexDashboard = menus.menus.findIndex((item) => item.nome === "Dashboard");

        if (indexDashboard < 0) {
          return;
        }

        if (["PLATAFORMA", "INTEGRADOR"].includes(sessao?.empresaDTO?.tipoEmpresa)) {
          menus.menus[indexDashboard] = {
            ...menus.menus[indexDashboard],
            filhos: [criarDashboardNovo()],
          };
        } else {
          menus.menus[indexDashboard] = {
            ...menus.menus[indexDashboard],
            filhos: listarDashboardsComBotaoNovo(),
          };
        }

        setListaMenuAtual(menus);
      } catch (error) {}
    }
  }, [listaDashboards]);

  useEffect(() => {
    if (listaDashboards && listaMenu) {
      const menuComDashboards = {
        ...listaMenu,
        menus: [...(listaMenu.menus || [])],
      };

      const sessao = obterStorage("sessao");
      const indexDashboard = menuComDashboards.menus.findIndex((item) => item.nome === "Dashboard");

      if (indexDashboard >= 0) {
        const filhosDashboard = ["PLATAFORMA", "INTEGRADOR"].includes(
          sessao?.empresaDTO?.tipoEmpresa,
        )
          ? [criarDashboardNovo()]
          : listarDashboardsComBotaoNovo();

        menuComDashboards.menus[indexDashboard] = {
          ...menuComDashboards.menus[indexDashboard],
          filhos: filhosDashboard,
        };
      }

      setListaMenuAtual(menuComDashboards);
    } else {
      setListaMenuAtual(listaMenu);
    }
  }, [listaMenu, listaDashboards]);

  function Corpo(params) {
    // Com a IA liberada para a empresa, o botão nunca some: em tela estreita a loja desce para a 2ª linha.
    if (!versaoDesktopAtiva && iaDisponivel) {
      return (
        <S.Container>
          <S.LinhaIcones $comIA>
            <S.ColunaMovel>
              <S.LinhaMovelTopo>
                <WaybeLogo />
                <S.GrupoAcoes $compacto>
                  <BotaoAssistente tipo="ia" compacto />
                  {/* <BotaoAssistente tipo="chatbot" compacto /> */}
                  <Notificacoes mobile={true} />
                  <Configuracoes mobile={true} />
                </S.GrupoAcoes>
              </S.LinhaMovelTopo>
              <AlterarLoja />
            </S.ColunaMovel>
          </S.LinhaIcones>
        </S.Container>
      );
    }

    return versaoDesktopAtiva ? (
      <S.Container>
        <S.LinhaIcones $comIA={iaDisponivel}>
          {iaDisponivel ? (
            <>
              <S.GrupoAcoes $fixo>
                <WaybeLogo />
                <BotaoAssistente tipo="ia" />
              </S.GrupoAcoes>
              <S.GrupoAcoes $flexivel>
                <AlterarLoja />
                {/* <BotaoAssistente tipo="chatbot" /> */}
              </S.GrupoAcoes>
            </>
          ) : (
            <>
              <WaybeLogo />
              <AlterarLoja />
            </>
          )}
          <ExpandableSearch menusLiberados={menusLiberadosMemo} />
          <Notificacoes />

          <S.BlocoItem $comIA={iaDisponivel}>
            <Perfil />
            <BotaoEngrenagem />
          </S.BlocoItem>
        </S.LinhaIcones>

        <LinhaMenus
          key={`menu-${contratoWaychefAtivo}`}
          menusLiberados={menusLiberadosMemo}
          menuFixo={menuFixo}
          rotaCardapio={rotaCardapio}
          MenuItemNovo={MenuItemNovo}
        />
      </S.Container>
    ) : (
      <S.Container>
        <S.LinhaIcones>
          <S.Coluna
            style={{
              alignItems: "flex-start",
              minWidth: 250,
            }}
          >
            <WaybeLogo />
            <AlterarLoja />
          </S.Coluna>

          <Notificacoes mobile={true} />
          <Configuracoes mobile={true} />
        </S.LinhaIcones>
      </S.Container>
    );
  }

  const WaybeLogo = () => {
    function larguraResponsiva() {
      if (largura > LARGURA_QUEBRA) {
        return 160;
      } else {
        return 60;
      }
    }

    async function trocarParaPlataforma() {
      try {
        const response = await get("/usuario-sessao/usuario/buscar-empresas-disponiveis");
        const empresasDisponiveis = Array.isArray(response.data) ? response.data : [];
        const possuiEmpresaPlataforma = empresasDisponiveis.some(
          (empresa) => empresa?.idEmpresa === 1,
        );

        if (possuiEmpresaPlataforma) {
          const dados = await trocarEmpresa({ idEmpresa: 1 });
          abrirCarregamento();
          await buscarDashboards(dados.tokenDTO.token);
          await buscarDadosEmpresaStorage();
        }
      } catch (e) {
        if (e?.response?.status === 401)
          toast.error("Usuário não possui permissão para acessar essa empresa.");
      } finally {
        await fecharCarregamento();
        navigate("/");
      }
    }

    return (
      <img
        onClick={trocarParaPlataforma}
        src={WaybeImagemGrande}
        alt="Logo da empresa Waybe"
        style={{
          width: larguraResponsiva(),
          marginBottom: 10,
          cursor: "pointer",
        }}
      />
    );
  };

  const identificarTipoUsuario = () => {
    try {
      const sessao = obterStorage("sessao");
      if (
        sessao?.empresaDTO.tipoEmpresa == "PLATAFORMA" ||
        sessao?.empresaDTO.tipoEmpresa == "INTEGRADOR"
      ) {
        setMostrarModalSelecionarEmpresaPopup(true);
      } else {
        navigate("/empresa");
      }
    } catch (error) {
      console.error(error);
      navigate("/empresa");
    }
  };

  const AlterarLoja = () => {
    return versaoDesktopAtiva ? (
      <S.AlterarLojaContainer $comIA={iaDisponivel} onClick={() => identificarTipoUsuario()}>
        <S.Linha style={{ alignItems: versaoDesktopAtiva ? "center" : "flex-start" }}>
          <IconeLoja
            style={{
              width: 30,
              marginRight: 10,
              fill: theme.cores.brand40neutral100,
            }}
          />
          <S.Coluna style={{ alignItems: "flex-start" }}>
            <S.NomeEmpresa>{dadosEmpresa?.apelido}</S.NomeEmpresa>
            <S.TipoEmpresa>{dadosEmpresa?.tipoEmpresa}</S.TipoEmpresa>
          </S.Coluna>
        </S.Linha>

        <S.BotaoTransparente>
          <S.TextoAlterarLoja style={{ fontSize: 14 }}>Alterar empresa</S.TextoAlterarLoja>
        </S.BotaoTransparente>

        <S.StyledBottomSheet open={abrir} onDismiss={() => setAbrir(false)}>
          <S.CabecalhoModal>
            <S.TextoCabecalhoModal>Alternar empresa</S.TextoCabecalhoModal>
            <IconeBotao onClick={fecharModal}>
              <X size={24} color={theme.cores.botaoModal} />
            </IconeBotao>
          </S.CabecalhoModal>

          <S.ContainerDireita>
            <S.ContainerInput>
              <S.Input placeholder="Pesquisar empresa" />
              <IconeBotao>
                <MagnifyingGlass
                  size={22}
                  color={theme.cores.corInput}
                  style={{ marginLeft: -40 }}
                />
              </IconeBotao>
            </S.ContainerInput>
          </S.ContainerDireita>

          <S.ContainerTabela>
            <TabelaOrdenada dados={dadosTabela} alternarEmpresa={true} />
          </S.ContainerTabela>
        </S.StyledBottomSheet>
      </S.AlterarLojaContainer>
    ) : (
      <S.AlterarLojaContainer $comIA={iaDisponivel} onClick={() => identificarTipoUsuario()}>
        <S.Linha style={{ width: "100%" }}>
          <IconeLoja
            style={{
              width: 20,
              marginTop: -5,
              marginRight: 10,
              fill: theme.cores.brand40neutral100,
            }}
          />
          <S.Coluna
            style={{
              alignItems: "flex-start",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <S.NomeEmpresa>{dadosEmpresa?.apelido}</S.NomeEmpresa>
            <S.Linha style={{ justifyContent: "space-between", width: "100%" }}>
              <S.TipoEmpresa>{dadosEmpresa?.tipoEmpresa}</S.TipoEmpresa>
              <S.BotaoTransparente>
                <S.TextoAlterarLoja style={{ fontSize: 14 }}>Alterar empresa</S.TextoAlterarLoja>
              </S.BotaoTransparente>

              <S.StyledBottomSheet open={abrir} onDismiss={() => setAbrir(false)}>
                <S.CabecalhoModal>
                  <S.TextoCabecalhoModal>Alternar empresa</S.TextoCabecalhoModal>
                  <IconeBotao onClick={fecharModal}>
                    <X size={24} color={theme.cores.botaoModal} />
                  </IconeBotao>
                </S.CabecalhoModal>

                <S.ContainerDireita>
                  <S.ContainerInput>
                    <S.Input placeholder="Pesquisar empresa" />
                    <IconeBotao>
                      <MagnifyingGlass
                        size={22}
                        color={theme.cores.corInput}
                        style={{ marginLeft: -40 }}
                      />
                    </IconeBotao>
                  </S.ContainerInput>
                </S.ContainerDireita>

                <S.ContainerTabela>
                  <TabelaOrdenada dados={dadosTabela} alternarEmpresa={true} />
                </S.ContainerTabela>
              </S.StyledBottomSheet>
            </S.Linha>
          </S.Coluna>
        </S.Linha>
      </S.AlterarLojaContainer>
    );
  };

  const renderMenu = (todosMenus) => {
    const sessao = obterStorage("sessao");
    const permissoesWaybe = sessao?.contratoWaybeAtualDTO?.permissoesWaybe;
    const permissoesWaymenu = sessao?.contratoWaymenuAtualDTO?.listaItens;
    const permissoesWaychef = sessao?.contratoWaychefAtualDTO?.listaItens;
    const perfil = sessao?.usuarioLogadoDTO?.usuarioPerfilEmpresaDTO;
    const listaPrivilegios = perfil?.listaPrivilegios;
    const isMaster = perfil?.tipoPerfilUsuario === "MASTER";

    const resultado = [];

    for (const item of todosMenus) {
      if (!item) {
        continue;
      }

      if (item["ocultar"]) {
        continue;
      }

      if (item["tipoEmpresa"] != null) {
        const temTipoEmpresa = item["tipoEmpresa"].some(
          (tipo) => tipo === sessao?.empresaDTO.tipoEmpresa,
        );

        if (!temTipoEmpresa) {
          continue;
        }
      }

      if (permissoesWaybe && item["itemContratoWaybe"] != null) {
        const temNoContrato = item["itemContratoWaybe"].every((contrato) =>
          permissoesWaybe.includes(contrato),
        );

        if (!temNoContrato) {
          continue;
        }
      }

      if (permissoesWaychef && item["itemContratoWaychef"] != null) {
        const temNoContrato = item["itemContratoWaychef"].every((contrato) =>
          permissoesWaychef.includes(contrato),
        );

        if (!temNoContrato) {
          continue;
        }
      }

      if (permissoesWaymenu && item["itemContratoWaymenu"] != null) {
        const temNoContrato = item["itemContratoWaymenu"].every((contrato) =>
          permissoesWaymenu.includes(contrato),
        );

        if (!temNoContrato) {
          continue;
        }
      }

      if (listaPrivilegios && item["permissoes"] != null) {
        const nivelNecessario = item["nivelNecessario"];
        const chavePorNivel = {
          EXCLUIR: "excluir",
          ALTERAR: "alterar",
          INSERIR: "inserir",
          CONSULTAR_PERMITIR: "consultar",
        };

        const chavePermissao = nivelNecessario ? chavePorNivel[nivelNecessario] : "consultar";

        const permissoesValidas = item["validarApenasUmaPermissao"]
          ? item["permissoes"].some((perm) => {
              const permissao = verificarPermissao(perm);
              return chavePermissao ? permissao[chavePermissao] : false;
            })
          : item["permissoes"].every((perm) => {
              const permissao = verificarPermissao(perm);
              return chavePermissao ? permissao[chavePermissao] : false;
            });

        if (!permissoesValidas) {
          continue;
        }
      }

      if (item.filhos) {
        const filhosResultado = renderMenu(item.filhos);
        if (filhosResultado.length > 0) {
          resultado.push({ ...item, filhos: filhosResultado });
        } else {
          continue;
        }
      } else {
        resultado.push(item);
      }
    }
    return resultado;
  };

  const menusLiberadosMemo = useMemo(() => {
    if (!listaMenuAtual?.menus) return [];
    return renderMenu(listaMenuAtual.menus);
  }, [listaMenuAtual, contratoWaychefAtivo]);

  const rotaCardapio = useMemo(() => {
    return location.pathname.includes("/produtos/cardapio/wayservice/avancado");
  }, [location.pathname]);

  const MenuItemNovo = ({ menu, titulo, larguraMinima }) => {
    const [aberto, setAberto] = useState(false);

    if (menu.oculto) {
      return <></>;
    }

    return menu.filhos != null && menu.filhos.length > 0 ? (
      <S.PopupCustomizado
        onOpen={() => setAberto(true)}
        onClose={() => setAberto(false)}
        trigger={
          <S.ContainerMenuItem
            style={{ minWidth: larguraMinima, ...menu?.styleContainer }}
            $aberto={aberto}
            atualizar={
              identificarRotaSelecionada(removerCaracteresEspeciais(titulo).toLowerCase()) &&
              atualizarMenu
                ? true
                : false
            }
            selecionado={identificarRotaSelecionada(
              removerCaracteresEspeciais(titulo).toLowerCase(),
            )}
          >
            {menu?.svg ? (
              menu?.svg
            ) : (
              <FontAwesomeIcon icon={menu.icone} style={{ color: theme.cores.textoSimples }} />
            )}

            <S.TextoMenuItem className="icone-menu-painel-transicao">{titulo}</S.TextoMenuItem>

            <IconeExpandir className="icone-menu-painel-transicao icone-menu-painel-transicao-inverter" />
          </S.ContainerMenuItem>
        }
        position={["bottom left", "left bottom"]}
        keepTooltipInside
        arrowStyle={{ visibility: "hidden" }}
        offsetY={10}
      >
        {(close) => (
          <ComponentePaginado
            Filho={S.MenuItemFilhoContainer}
            navegacaoInicial={menu.filhos}
            onItemClick={close}
          />
        )}
      </S.PopupCustomizado>
    ) : (
      <S.ContainerMenuItem $aberto={aberto}>
        <FontAwesomeIcon icon={menu.icone} style={{ color: theme.cores.textoSimples }} />

        <S.TextoMenuItem className="icone-menu-painel-transicao">{titulo}</S.TextoMenuItem>
      </S.ContainerMenuItem>
    );
  };

  const MenuItem = ({ menu, titulo }) => {
    const [aberto, setAberto] = useState(false);
    return typeof menu === "object" ? (
      <S.PopupCustomizado
        onOpen={() => setAberto(true)}
        onClose={() => setAberto(false)}
        trigger={
          <S.ContainerMenuItem $aberto={aberto}>
            {menu.icone ? menu.icone : <></>}

            <S.TextoMenuItem className="icone-menu-painel-transicao">{titulo}</S.TextoMenuItem>

            <IconeExpandir className="icone-menu-painel-transicao icone-menu-painel-transicao-inverter" />
          </S.ContainerMenuItem>
        }
        position="bottom left"
        arrowStyle={{ visibility: "hidden" }}
        offsetY={21 + 4}
      >
        {(close) => (
          <ComponentePaginado
            Filho={S.MenuItemFilhoContainer}
            navegacaoInicial={menu}
            onItemClick={close}
          />
        )}
      </S.PopupCustomizado>
    ) : (
      <S.ContainerMenuItem
        $aberto={aberto}
        onClick={() => funcoesBotaoNavegacao[typeof menu](menu)}
      >
        {menu.icone ? menu.icone : <></>}
        <S.TextoMenuItem className="icone-menu-painel-transicao">{titulo}</S.TextoMenuItem>
      </S.ContainerMenuItem>
    );
  };

  const MenuMobile = () => {
    return (
      <S.PopupCustomizado
        trigger={
          <IconeMenuMobile
            style={{
              fill: theme.cores.brand40neutral100,
              marginTop: 20,
              transform: "scale(1.2)",
            }}
          />
        }
        position="bottom right"
        arrowStyle={{ visibility: "hidden" }}
      >
        <div style={{ width: 200, height: 200 }}></div>
      </S.PopupCustomizado>
    );
  };

  const selecionarEmpresa = (id, nome) => {
    try {
      abrirCarregamento(`Carregando ${nome}...`);
      trocarEmpresa({ idEmpresa: id })
        .then(async (dados) => {
          await buscarDashboards(dados.tokenDTO.token);
          await buscarDadosEmpresaStorage();

          toast.success("Empresa alterada com sucesso!");
          setTimeout(() => {
            fecharCarregamento().then(() => {
              window.location.href = "/";
            });
          }, 500);
        })
        .catch((erro) => {
          fecharCarregamento().then(() => {
            toast.error("Não foi possivel alterar empresa!");
          });
        });
    } catch (error) {}
  };

  return (
    <div
      style={{
        position: "relative",
        zIndex: 2,
      }}
    >
      {mostrarModalSelecionarEmpresaPopup && (
        <SelecionarEmpresaPopup
          selecionarEmpresa={selecionarEmpresa}
          fecharTabela={() =>
            setMostrarModalSelecionarEmpresaPopup(!mostrarModalSelecionarEmpresaPopup)
          }
        />
      )}

      {listaMenuAtual != undefined && Corpo()}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
          backgroundColor: theme.cores.surfaceBackground1,
        }}
      />
    </div>
  );
};

export default Header;
